import createIcon from '../../createIcon';

/**
 * @component @name AltRoute
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS43OCAxMS4xNkw4LjM2IDEyLjU4QzcuNjggMTEuODkgNy4wMiAxMSA2LjU3IDkuNjRMOC41MSA5LjE1QzguODMgMTAuMDQgOS4yOCAxMC42NSA5Ljc4IDExLjE2Wk0xMSA2TDcgMkwzIDZINi4wMkM2LjA0IDYuODEgNi4xIDcuNTQgNi4yMSA4LjE3TDguMTUgNy42OEM4LjA4IDcuMiA4LjAzIDYuNjMgOC4wMiA2SDExWk0yMSA2TDE3IDJMMTMgNkgxNS45OUMxNS44OSA5LjY4IDE0LjcxIDEwLjc1IDEzLjQ1IDExLjg4QzEyLjk1IDEyLjMyIDEyLjQ0IDEyLjggMTIgMTMuNDNDMTEuNjYgMTIuOTQgMTEuMjcgMTIuNTUgMTAuODcgMTIuMTlMOS40NiAxMy42QzEwLjM5IDE0LjQ1IDExIDE1LjE0IDExIDE3VjIySDEzVjE3QzEzIDE0Ljk4IDEzLjcxIDE0LjM0IDE0Ljc5IDEzLjM3QzE2LjE3IDEyLjEzIDE3Ljg3IDEwLjU5IDE3Ljk5IDZIMjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AltRoute = createIcon('AltRoute', [
  [
    'path',
    {
      d: 'M9.78 11.16L8.36 12.58C7.68 11.89 7.02 11 6.57 9.64L8.51 9.15C8.83 10.04 9.28 10.65 9.78 11.16ZM11 6L7 2L3 6H6.02C6.04 6.81 6.1 7.54 6.21 8.17L8.15 7.68C8.08 7.2 8.03 6.63 8.02 6H11ZM21 6L17 2L13 6H15.99C15.89 9.68 14.71 10.75 13.45 11.88C12.95 12.32 12.44 12.8 12 13.43C11.66 12.94 11.27 12.55 10.87 12.19L9.46 13.6C10.39 14.45 11 15.14 11 17V22H13V17C13 14.98 13.71 14.34 14.79 13.37C16.17 12.13 17.87 10.59 17.99 6H21Z',
      key: 'df61sa',
    },
  ],
]);

export default AltRoute;
